import { combineReducers } from 'redux'
import { GlobalReducer } from './globalReducers'

export default combineReducers({
	global: GlobalReducer
})


// WEBPACK FOOTER //
// ./src/redux/reducers/index.js